import { unitConverter } from 'utils/unitConverter/unitConverter'

export const getAppliedWater = ({
  status,
  appliedWater,
}: {
  status: string
  appliedWater: number | null
}) => {
  if (status === 'on') {
    return unitConverter.irrigationActivity(appliedWater, { decimalPlaces: 2 }).valueWithSuffix()
  }

  return null
}
